import React from "react";
import {
  Transition,
  Button,
  Form,
  Icon,
  Message,
  Segment
} from "semantic-ui-react";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";

function renderTextField({ input, ...others }) {
  return <Form.Input fluid iconPosition="left" {...input} {...others} />;
}

function errorMessage(mensaje, color = "red") {
  return !_.isEmpty(mensaje) ? (
    <Segment basic>
      <Message negative>
        <Message.Header>
          <Icon name="warning circle" style={{ color }} />
          {mensaje}
        </Message.Header>
      </Message>
    </Segment>
  ) : null;
}

function LoginForm(props) {
  const { handleSubmit, loginError } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Segment>
        <Field
          required
          id="email"
          name="email"
          type="text"
          placeholder="Usuario"
          component={renderTextField}
          icon="user"
        />
        <Field
          required
          id="password"
          name="password"
          type="password"
          placeholder="Contraseña"
          component={renderTextField}
          icon="lock"
        />
        <Transition.Group animation="drop" duration={500}>
          {errorMessage(loginError)}
        </Transition.Group>
        <Button fluid type="submit" color="pink">
          Acceder
        </Button>
      </Segment>
    </Form>
  );
}

export default reduxForm({ form: "login" })(LoginForm);



// WEBPACK FOOTER //
// ./src/pages/loginPage/LoginForm.jsx